/** Картинка-превью ролика YouTube по его ID. */
export function youtubeThumbnailUrl(videoId: string): string {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
}

/** Адрес плеера YouTube с автозапуском; без рекомендаций чужих роликов в конце. */
export function youtubeEmbedUrl(videoId: string): string {
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
}
